module.exports = __webpack_public_path__ + "img/logo3.df5c95ef.png";